import BookingIcon from "@mui/icons-material/Book";
import { PageHeader } from "common";
import BookingList from "features/bookings/BookingList";

export default function PartnerBookingList() {
  return (
    <>
      <PageHeader avatar={<BookingIcon />} title="Foglalások" />
      <BookingList id="partner-booking-list" showHeader={false} isPartnerView />
    </>
  );
}
